module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"volunteer":"Bénévole"},"en":{"volunteer":"Volunteer"}}')
  delete Component.options._Ctor
}
